import hexStringToArrayBuffer from './hexStringToArrayBuffer.js';
import getContentEncryptionIv from './getContentEncryptionIv.js';
import { arrayBufferToBase64 } from './base64ArrayBufferTranslator.js';

export default {
    async encryptText(rawText) {
        // const salt = crypto.getRandomValues(new Uint8Array(process.env.VITE_CONTENT_ENCRYPTION_IV.length / 2));
        const salt = [];

        const encrypted = await this.encryptArrayBuffer(new TextEncoder().encode(rawText));

        return arrayBufferToBase64([...salt, ...new Uint8Array(encrypted)]);
    },
    async encryptArrayBuffer(arrayBuffer) {
        const importedKey = await crypto.subtle.importKey(
            'raw',
            hexStringToArrayBuffer(import.meta.env.VITE_CONTENT_ENCRYPTION_PASSPHRASE),
            { name: 'AES-GCM', length: 256 },
            false,
            ['encrypt']
        );

        return await crypto.subtle.encrypt(
            {
                name: 'AES-GCM',
                iv: await getContentEncryptionIv(),
            },
            importedKey,
            arrayBuffer
        );
    },
};
